// Banded/nested column headers -> autotable's `head` (array of arrays, one per header row,
// with colSpan on band parents and rowSpan on leaves) — native, documented autotable
// behavior. No DevExtreme internals involved, unlike the old engine's positional
// columnWidths-array approach.
export function countLeaves(col) {
    if (col.visible === false) return 0;
    if (!col.columns) return 1;
    return col.columns.reduce((sum, c) => sum + countLeaves(c), 0);
}

export function maxDepth(columns) {
    let depth = 1;
    columns.forEach((col) => {
        if (col.columns) depth = Math.max(depth, 1 + maxDepth(col.columns));
    });
    return depth;
}

export function buildHead(columns) {
    const visibleColumns = columns.filter((c) => c.visible !== false);
    const depth = maxDepth(visibleColumns);
    const rows = Array.from({ length: depth }, () => []);

    function walk(cols, level) {
        cols.forEach((col) => {
            if (col.visible === false) return;
            if (col.columns) {
                const leafCount = countLeaves(col);
                if (leafCount === 0) return;
                rows[level].push({ content: col.caption || '', colSpan: leafCount });
                walk(col.columns, level + 1);
            } else {
                rows[level].push({ content: col.caption || '', rowSpan: depth - level });
            }
        });
    }
    walk(visibleColumns, 0);
    return rows;
}
